import usePageTitle from "@entrilia/shared/hooks/usePageTitle";
import useClientContext from "../../../context/useClientContext";
import ApiGatewayIcon from "../../common/domain-icons/ApiGatewayIcon";
import IntegrationPageContainer from "../integration/IntegrationPageContainer";
import ApiGatewayTabs from "./ApiGatewayTabs";

const promotionText =
  "Manage subscriptions to the Entrilia API by granting users access to the Entrilia Developer Portal. This enables software developers to utilize Entrilia APIs, access documentation, and manage API keys, facilitating integration development and data management within Entrilia.";

const ApiGatewayPage = () => {
  usePageTitle("API Gateway");

  const { apiGatewayApp } = useClientContext();

  return (
    <IntegrationPageContainer
      title="API Gateway"
      Icon={ApiGatewayIcon}
      overviewText={promotionText}
      appStatus={apiGatewayApp?.status}
      maxWidth="xl"
    >
      <ApiGatewayTabs />
    </IntegrationPageContainer>
  );
};

export default ApiGatewayPage;
